import { render, staticRenderFns } from "./OfferItemWithoutImage.vue?vue&type=template&id=0c3f56e8&scoped=true&"
import script from "./OfferItemWithoutImage.vue?vue&type=script&lang=ts&"
export * from "./OfferItemWithoutImage.vue?vue&type=script&lang=ts&"
import style0 from "./OfferItemWithoutImage.vue?vue&type=style&index=0&id=0c3f56e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f56e8",
  null
  
)

export default component.exports